module.exports = __webpack_public_path__ + "img/54_31.f292abde.png";